import { createAsyncThunk } from "@reduxjs/toolkit";

import type { PaymentData } from "@jti/fe-common";
import { PgsApi } from "@jti/rest-api";

export const fetchPaymentMethod = createAsyncThunk(
  "order/fetchPaymentMethod",
  async (paymentToken: string): Promise<PaymentData> => {
    const pgs = PgsApi.init();

    return pgs.getOrderPaymentMethod(paymentToken);
  }
);
